module.exports = __webpack_public_path__ + "static/youth-on-course-4cdc421be82c2dc5f977a984d72a63d3.png";